import React from "react";
import { Form } from "react-final-form";

import { Dialog } from "../../../../../../../components/dialogs/Dialog/Dialog";
import { Button } from "../../../../../../../components/Buttons/Button/Button";
import AlternativeName from "../../../../../components/AlternativeName";

import TemplateNameField from "./TemplateNameField";

import styles from "./styles.module.scss";

const CreateTemplateDialog = ({ isOpen, initialValues, onClose, onSubmitFormDialog }) => (
    <Dialog
        classes={{ paper: styles.editIdentifierDialog }}
        title="Template"
        isOpen={isOpen}
        onClose={onClose}
    >
        <Form
            onSubmit={onSubmitFormDialog}
            initialValues={initialValues}
            render={({ handleSubmit, values }) => (
                <form onSubmit={handleSubmit}>
                    <TemplateNameField />

                    {
                        values.name === "other" && (
                            <AlternativeName />
                        )
                    }

                    <div className={styles.editIdentifierBtnRow}>
                        <Button
                            className={styles.editIdentifierBtn}
                            colorFirm={2}
                            type="submit"
                        >
                                Save
                        </Button>

                        <Button
                            className={styles.editIdentifierBtn}
                            colorFirm={3}
                            onClick={onClose}
                        >
                                Close
                        </Button>
                    </div>
                </form>
            )}
        />
    </Dialog>
);

export default CreateTemplateDialog;
